import Vue from 'vue'
import Vuex from 'vuex'
import { Toast } from 'vant'



/**
 * 各个模块
 */
import user from './modules/user';

/**
 * 全局状态管理
 */
const state = {
	routeIsBack: false,
	reportAuth:false,
	payAuth:false,
	visaAuth:false,
	accountsAuth:false,

};
const actions = {
	/**
	 * 显示提示 msg.type 类型  msg.data 消息内容
	 * @param commit
	 * @param msg
	 */
	showMassage({commit}, msg){
		console.log(msg)
		Toast({
			type: msg.type,
			message: msg.message
		})
	}
};
const mutations = {
	/**
	 * 更改路由前进后退状态
	 * @param state
	 * @param boolean
	 * @constructor
	 */
	UPDATE_ROUTER_IS_BACK(state, boolean){
		state.routeIsBack = !!boolean
	},
	UPDATE_REPORT_AUTH(state,boolean){
		state.reportAuth=boolean
	},
	UPDATE_VISA_AUTH(state,boolean){
		state.visaAuth=boolean
	},
	UPDATE_PAY_AUTH(state,boolean){
		state.payAuth=boolean
	},
	UPDATE_ACCOUNTS_AUTH(state,boolean){
		state.accountsAuth=boolean
	}
};
const getters = {};

Vue.use(Vuex);
export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
	modules: {
		user
	}
});
